import { Navigate } from 'react-router-dom';
import React, { FC, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import { privateLoginStatus } from '@/state/privateAuth';
import routes from '@/components/private/routes';

export type UnauthenticatedRouteProps = PropsWithChildren;

/**
 * Guards its children, redirecting to the private app if the current user is logged in.
 */
const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = ({ children }) => {
  const loginStatus = useAtomValue(privateLoginStatus);

  if (loginStatus === 'LOGGED_IN') {
    return <Navigate to={routes.newAuthRequest} replace />;
  }

  return <>{children}</>;
};

export default UnauthenticatedRoute;
